var map = {
	"./basel.png": 53,
	"./bern.png": 54,
	"./biel.png": 55,
	"./chur.png": 56,
	"./genf.png": 57,
	"./lausanne.png": 58,
	"./lugano.png": 59,
	"./luzern.png": 60,
	"./schaffhausen.png": 61,
	"./st-gallen.png": 62,
	"./winterthur.png": 63,
	"./zuerich.png": 64
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 52;